import WarehouseList from '@/components/Warehouse/WarehouseList'
import WarehouseForm from '@/components/Warehouse/WarehouseForm'
import WarehouseDetail from '@/components/Warehouse/WarehouseDetail'

let WarehouseRouter = [{
  path: '/warehouse',
  name: 'WarehouseList',
  component: WarehouseList,
  meta: {
    title: 'Entrepôts',
    requiresAuth: true,
    authorizations: ['warehouse_index', 'desktop_access']
  }
}, {
  path: '/warehouse/new',
  name: 'WarehouseNew',
  component: WarehouseForm,
  meta: {
    title: 'Nouvel entrepôt',
    requiresAuth: true,
    authorizations: ['warehouse_new', 'desktop_access']
  }
}, {
  path: '/warehouse/:id/edit',
  name: 'WarehouseEdit',
  component: WarehouseForm,
  meta: {
    title: 'Modifier un entrepôt',
    requiresAuth: true,
    authorizations: ['warehouse_edit', 'desktop_access']
  }
}, {
  path: '/warehouse/:id',
  name: 'WarehouseDetail',
  component: WarehouseDetail,
  meta: {
    title: 'Fiche entrepôt',
    requiresAuth: true,
    authorizations: ['warehouse_show', 'desktop_access']
  }
}]

export default WarehouseRouter



// WEBPACK FOOTER //
// ./src/components/Warehouse/router.js